import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInformationCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "information-circle" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14.25,16.5H13.5A1.5,1.5,0,0,1,12,15V11.25a.75.75,0,0,0-.75-.75H10.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M11.625,6.75A.375.375,0,1,0,12,7.125a.375.375,0,0,0-.375-.375h0"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "a",
			cx: 12,
			cy: 12,
			r: 11.25
		})
	]
});
export default SvgInformationCircle;
